const LocationMarker = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M12 22c0 18 20 40 20 40s20-22 20-40a20 20 0 0 0-40 0zm12 0a8 8 0 1 1 8 8 8 8 0 0 1-8-8z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M24 22a8 8 0 0 0 8 8v32S12 40 12 22A20 20 0 0 1 32 2v12a8 8 0 0 0-8 8z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default LocationMarker;
